import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { appxTgtClassNameConfig } from './AppxTgtClass.name';

enum AppxTgtClass {
  unspecified = '00',
  appxSixteenOneTgtAsset = '10',
  appxSixteenTwoTgtAsset = '20',
  appxSixteenUpperTgtAsset = '61',
  appxSixteenLowerTgtAsset = '62',
}

const appxTgtClassMap = new Map([
  ['00', AppxTgtClass.unspecified],
  ['10', AppxTgtClass.appxSixteenOneTgtAsset],
  ['20', AppxTgtClass.appxSixteenTwoTgtAsset],
  ['61', AppxTgtClass.appxSixteenUpperTgtAsset],
  ['62', AppxTgtClass.appxSixteenLowerTgtAsset],
]);

const rawValueMayToAppxTgtClass = rawValueToEnumWithDefault(appxTgtClassMap, '');

const appxTgtClassToDisplay = enumToNameWithDefault(AppxTgtClass, appxTgtClassNameConfig);

const appxTgtClassToDisplayWithPrefix = enumToNameWithDefault(AppxTgtClass, appxTgtClassNameConfig, true);

export { AppxTgtClass, appxTgtClassToDisplay, appxTgtClassToDisplayWithPrefix, rawValueMayToAppxTgtClass };
